import React from 'react';
import { Box, BoxProps } from '@material-ui/core';

interface IProps extends BoxProps {
    className?: string;
}

export const FormField: React.FC<IProps> = ({
    children,
    className,
    ...boxProps
}) => (
    <Box className={className} mb={1} {...boxProps}>
        {children}
    </Box>
);
